import Vue from 'vue'
import ConfigPlugin from '@vuecmp/plugins/Config'

export const config = { // eslint-disable-line import/prefer-default-export
  stateVersion: 5,
  errors: [
    {
      code: 1,
      msg: 'errors.vehicleNotFound',
    },
    {
      code: 2,
      msg: 'errors.vehicleNotFound',
    },
    {
      code: 3,
      msg: 'errors.technicalError',
    },
    {
      code: 4,
      msg: 'errors.technicalErrorLater',
    },
    {
      code: 5,
      msg: 'errors.maintenance',
    },
    {
      code: 6,
      msg: 'errors.technicalError',
    },
    {
      code: 7,
      msg: 'errors.technicalError',
    },
    {
      code: 8,
      msg: 'errors.declined',
    },
    {
      code: 100,
      msg: 'errors.declined',
    },
  ],
}

Vue.use(ConfigPlugin, { config })
